import React from 'react'
import { css, styled } from 'styled-components'

const Row = styled.div<{
  $vPadding?: string
  $hPadding?: string
  $tPadding?: string
  $rPadding?: string
  $bPadding?: string
  $lPadding?: string
  $hasOnClick?: boolean
  $pageTitle?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${({ $tPadding, $vPadding }) => $tPadding ?? $vPadding};
  padding-right: ${({ $rPadding, $hPadding }) => $rPadding ?? $hPadding};
  padding-bottom: ${({ $bPadding, $vPadding }) => $bPadding ?? $vPadding};
  padding-left: ${({ $lPadding, $hPadding }) => $lPadding ?? $hPadding};
  box-sizing: content-box;
  min-height: ${({ $pageTitle }) => ($pageTitle ? '4rem' : 'inherit')};
  flex-shrink: 0;
  width: 100%
    ${({ $hasOnClick, theme }) =>
      $hasOnClick &&
      css`
        cursor: pointer;
        background-color: ${theme.forecast.defaultGhostButton};
        &:hover {
          background-color: ${theme.forecast.hoverGhostButton};
        }
        &:active {
          background-color: ${theme.forecast.activeGhostButton};
          color: ${theme.forecast.activeText};
        }
      `};
`

const LeadingContent = styled.div<{
  $pageTitle?: boolean
  $contentHeight?: string
}>`
  display: flex;
  align-items: center;
  min-height: ${({ $contentHeight }) => $contentHeight ?? '2.5rem'};
  gap: 0.5rem;
  font-size: ${({ $pageTitle }) => ($pageTitle ? '1.125rem' : 'inherit')};
  font-weight: ${({ $pageTitle }) => ($pageTitle ? '600' : 'inherit')};
  color: ${({ theme }) => theme.forecast.defaultText};

  svg * {
    stroke: ${({ theme }) => theme.forecast.defaultText};
  }
`

const MiddleContent = styled.div`
  display: flex;
  align-items: center;
  min-height: 2.5rem;
`

const TrailingContent = styled.div`
  display: flex;
  align-items: center;
  min-height: 2.5rem;
  gap: 0.25rem;
  flex-shrink: 0;
`

type CantileverRowProps = {
  children?: React.ReactNode
  leadingContent?: React.ReactNode
  middleContent?: React.ReactNode
  trailingContent?: React.ReactNode
  contentHeight?: string
  backgroundColor?: string
  vPadding?: string
  hPadding?: string
  tPadding?: string
  rPadding?: string
  bPadding?: string
  lPadding?: string
  pageTitle?: boolean
  onClick?: (e?: React.MouseEvent<HTMLDivElement>) => void
}

export const CantileverRow: React.FC<CantileverRowProps> = ({
  children,
  leadingContent,
  middleContent,
  trailingContent,
  contentHeight,
  vPadding,
  hPadding,
  tPadding,
  rPadding,
  bPadding,
  lPadding,
  pageTitle,
  onClick,
}) => {
  return (
    <Row
      $vPadding={vPadding}
      $hPadding={hPadding}
      $tPadding={tPadding}
      $rPadding={rPadding}
      $bPadding={bPadding}
      $lPadding={lPadding}
      $hasOnClick={Boolean(onClick)}
      onClick={onClick}
      $pageTitle={pageTitle}>
      <LeadingContent $pageTitle={pageTitle} $contentHeight={contentHeight}>
        {leadingContent ?? children}
      </LeadingContent>
      {middleContent && <MiddleContent>{middleContent}</MiddleContent>}
      {trailingContent && <TrailingContent>{trailingContent}</TrailingContent>}
    </Row>
  )
}

export default CantileverRow
